import React, { PropsWithChildren } from 'react';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import Bem from '../../../../lib/bemUtils/bem';

type PageLead = PropsWithChildren<{
  modifier?: Modifier<'inline-icon' | 'invisible'>;
}>;

export function PageLead({ children, modifier }: PageLead) {
  return (
    // sometimes we render an invisible header (for design reasons mostly)
    <header className={Bem('page-lead', modifier)}>{children}</header>
  );
}
